import { z } from 'zod';

export const issueAssigneeUpdatedNotificationMetadataSchema = z.object({
	projectId: z.string(),
	issueDetails: z.object({
		description: z.string(),
		issueId: z.string(),
	}),
	assignedBy: z.string().optional(),
});

export type IIssueAssigneeUpdatedNotificationMetadata = z.infer<typeof issueAssigneeUpdatedNotificationMetadataSchema>;
